import React, { useEffect, useState, Fragment } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage/StandardPage'
import { Filter } from '../../components/_WMS/FilterComponent'
import { ApiResponse } from '../../typings/ApiResponse'
import { useApi } from '../../hooks/useApi'
import { Status } from '../../hooks/useFetchState'
import { usePagination } from '../../hooks/usePagination'
import { GenericTableV2 } from '../../components/_EOS/GenericTable'
import { SnackBar } from '../../components/SnackBar/Snackbar'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined'
import { ProcessEntity } from './Types/entities'
import { getProcessList, getUrlOriginalFile, getUrlResultFile } from './api'
import { useSnackbar } from '../../hooks/useSnackbar'
import { ProcessSearch } from '../../components/ProcessNew/ProcessSearch'
import { downloadBase64File, getColumnsConfig } from './config/config'

interface ProductPageProps {}

export const ProcessNew: React.FC<ProductPageProps> = () => {
  const { state, callApi } = useApi<ApiResponse<ProcessEntity>>()
  const { callApi: callApiGetResultFile } = useApi<ApiResponse<ProcessEntity>>()
  const { callApi: callApiGetOriginalUrlFile } =
    useApi<ApiResponse<ProcessEntity>>()
  const { isActive, isSuccess, message } = useSnackbar()
  const [selectedFilters, setSelectedFilters] = useState<Filter[]>([])
  const [loadingForm, setloadingForm] = useState(false)
  const pagination = usePagination(5)

  const requestProcess = (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => {
    callApi(getProcessList(filters, page, pageSize)).catch((error) => {
      console.log(error)
    })
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    const auxPage = pagination.pageSize !== pageSize ? 0 : page
    requestProcess(selectedFilters, auxPage, pageSize)
    pagination.setPagination(auxPage, pageSize)
  }

  const handleDownloadResultFile = (processId: number) => {
    callApiGetResultFile(getUrlResultFile(processId))
      .then((data) => {
        downloadBase64File(data.file, data.name, data.mimeType)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleDownloadOriginalFile = (processId: number) => {
    callApiGetOriginalUrlFile(getUrlOriginalFile(processId))
      .then((data) => {
        downloadBase64File(data.file, data.name, data.mimeType)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    setloadingForm(true)
    pagination.setPagination(0, pagination.pageSize)
    requestProcess(selectedFilters, 0, pagination.pageSize)
    setloadingForm(false)
  }, [selectedFilters])

  const columnsConfig = getColumnsConfig()
  return (
    <Fragment>
      <StandardPage pageTitle=''>
        <ProcessSearch
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          onSearchClick={requestProcess}
        />

        <GenericTableV2<ProcessEntity>
          data={state.data?.items || []}
          columns={columnsConfig}
          keyField='processId'
          loading={state.status === Status.Loading || loadingForm}
          pagination={{
            total: state.data?.totalItems || 0,
            page: pagination.page,
            pageSize: pagination.pageSize,
            onPageChange: handlePaginationChange
          }}
          actions={[
            {
              key: 'originalFile',
              label: 'Archivo Original',
              icon: <FileDownloadOutlinedIcon />,
              disabled: (row) => !row.fileName,
              onClick: (row) => handleDownloadOriginalFile(row.processId)
            },
            {
              key: 'resultFile',
              label: 'Resultado Carga',
              icon: <FactCheckOutlinedIcon />,
              disabled: (row) => !row.urlFileResulting,
              onClick: (row) => handleDownloadResultFile(row.processId)
            }
          ]}
        />
      </StandardPage>
      <SnackBar
        open={isActive}
        status={isSuccess ? 'success' : 'error'}
        message={message}
      />
    </Fragment>
  )
}
